import { render, staticRenderFns } from "./BottomAds.vue?vue&type=template&id=6e4e3db3"
import script from "./BottomAds.vue?vue&type=script&lang=js"
export * from "./BottomAds.vue?vue&type=script&lang=js"
import style0 from "./BottomAds.vue?vue&type=style&index=0&id=6e4e3db3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports